import '../scss/main.scss'

document.documentElement.dataset.theme = 'dark'

const $ = (selector, root = document) => root.querySelector(selector)
const $$ = (selector, root = document) => Array.from(root.querySelectorAll(selector))

function normalizeTrackValue(value) {
  if (value === undefined || value === null) return undefined
  if (typeof value === 'string') {
    const trimmed = value.trim()
    return trimmed === '' ? undefined : trimmed
  }
  return value
}

function getTrackContext(element, extra = {}) {
  if (!element) return extra

  const context = {
    page_context: normalizeTrackValue(element.dataset.trackContext),
    post_id: normalizeTrackValue(element.dataset.trackPostId),
    post_title: normalizeTrackValue(element.dataset.trackPostTitle),
    artist_name: normalizeTrackValue(element.dataset.trackArtist),
    genre_name: normalizeTrackValue(element.dataset.trackGenre),
    difficulty_level: normalizeTrackValue(element.dataset.trackLevel),
    destination_url: normalizeTrackValue(element.dataset.trackHref || element.getAttribute('href')),
    ...extra,
  }

  return Object.fromEntries(Object.entries(context).filter(([, value]) => value !== undefined))
}

function trackEvent(eventName, payload = {}) {
  const event = normalizeTrackValue(eventName)
  if (!event) return

  const cleanPayload = Object.fromEntries(
    Object.entries(payload).filter(([, value]) => value !== undefined && value !== null && value !== '')
  )

  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({ event, ...cleanPayload })
}

window.akordiTrack = trackEvent
window.akordiTrackContext = getTrackContext

function initShareButtons() {
  $$('a[data-track-event][data-track-network]').forEach((button) => {
    button.addEventListener('click', () => {
      trackEvent(button.dataset.trackEvent, getTrackContext(button, {
        share_network: normalizeTrackValue(button.dataset.trackNetwork),
      }))
    })
  })

  $$('[data-share-url], .btn--share').forEach((button) => {
    button.addEventListener('click', (event) => {
      event.preventDefault()
      const title = button.dataset.shareTitle || document.title
      const url = button.dataset.shareUrl || window.location.href
      if (navigator.share) {
        navigator.share({ title, url }).catch(() => {})
      } else {
        navigator.clipboard?.writeText(url).catch(() => {})
      }
    })
  })
}

function initCopyButtons() {
  $$('[data-copy-url]').forEach((button) => {
    button.addEventListener('click', () => {
      const url = button.dataset.copyUrl || window.location.href
      navigator.clipboard?.writeText(url).then(() => {
        button.classList.add('copied')
        trackEvent(button.dataset.trackEvent, getTrackContext(button, {
          share_network: normalizeTrackValue(button.dataset.trackNetwork),
          copied_url: url,
        }))
        setTimeout(() => button.classList.remove('copied'), 2000)
      }).catch(() => {})
    })
  })
}

function initTrackedActionButtons() {
  $$('[data-track-event="print_click"]').forEach((button) => {
    button.addEventListener('click', () => {
      trackEvent(button.dataset.trackEvent, getTrackContext(button))
    })
  })
}

function initTrackedLinkEvents() {
  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[data-track-event]')
    if (!link) return

    const eventName = normalizeTrackValue(link.dataset.trackEvent)
    if (!['suggestion_click', 'archive_song_open'].includes(eventName)) return

    trackEvent(eventName, getTrackContext(link, {
      view_mode: normalizeTrackValue(link.dataset.trackView),
    }))
  })
}

function initMobileNav() {
  const header = $('#site-header')
  const toggle = $('#nav-toggle')
  const mobileNav = $('#mobile-nav')
  if (!header || !toggle || !mobileNav) return

  const mobileLinks = $$('a', mobileNav)

  const setOpen = (isOpen) => {
    header.classList.toggle('site-header--menu-open', isOpen)
    document.body.classList.toggle('mobile-nav-open', isOpen)
    toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false')
    toggle.setAttribute('aria-label', isOpen ? 'Затвори мени' : 'Отвори мени')
    mobileNav.setAttribute('aria-hidden', isOpen ? 'false' : 'true')
  }

  const isDesktop = () => window.innerWidth > 720

  setOpen(false)

  toggle.addEventListener('click', () => {
    if (isDesktop()) return
    setOpen(toggle.getAttribute('aria-expanded') !== 'true')
  })

  mobileLinks.forEach((link) => {
    link.addEventListener('click', () => setOpen(false))
  })

  document.addEventListener('click', (event) => {
    if (isDesktop()) return
    if (toggle.getAttribute('aria-expanded') !== 'true') return
    if (header.contains(event.target)) return
    setOpen(false)
  })

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      setOpen(false)
      toggle.blur()
    }
  })

  window.addEventListener('resize', () => {
    if (isDesktop()) {
      setOpen(false)
    }
  })
}

function initArchiveViewToggle() {
  const gridButton = $('#view-grid')
  const listButton = $('#view-list')
  const grid = $('#view-grid-content')
  const list = $('#view-list-content')
  if (!gridButton || !listButton || !grid || !list) return

  const setView = (view) => {
    const isGrid = view === 'grid'
    grid.style.display = isGrid ? '' : 'none'
    list.style.display = isGrid ? 'none' : ''
    gridButton.classList.toggle('view-toggle__btn--active', isGrid)
    listButton.classList.toggle('view-toggle__btn--active', !isGrid)
    try { localStorage.setItem('akordi-view', view) } catch (_) {}
  }

  gridButton.addEventListener('click', () => {
    setView('grid')
    trackEvent('archive_view_change', getTrackContext(gridButton, { view_mode: 'grid' }))
  })
  listButton.addEventListener('click', () => {
    setView('list')
    trackEvent('archive_view_change', getTrackContext(listButton, { view_mode: 'list' }))
  })

  try {
    const saved = localStorage.getItem('akordi-view')
    if (saved === 'list') setView('list')
  } catch (_) {}
}

// ─── Live Search (home.php / data-live-search pages) ─────────────────────────

class LiveSearch {
  constructor(container) {
    this.container         = container
    this.postsWrap         = container.querySelector('[data-posts-wrap]')
    this.countNode         = document.getElementById('result-count')
    this.totalNode         = document.getElementById('result-total')
    this.searchInput       = document.getElementById('search-input') || $('.toolbar__search-input')
    this.sortSelect        = document.getElementById('sort-select')
    this.languageNotice    = document.querySelector('[data-search-language-notice]')
    this.sidebarGenreBtns  = $$('.sidebar-genre[data-genre]')
    this.toolbarGenrePills = $$('.toolbar__genre-pill[data-genre]')
    this.genreButtons      = [...this.sidebarGenreBtns, ...this.toolbarGenrePills]
    this.levelInputs       = $$('[data-level-filter]')
    this.levelChips        = $$('[data-level-chip]')

    this.ajaxurl = window.akordi_ajax?.ajaxurl || '/wp-admin/admin-ajax.php'
    this.nonce   = window.akordi_ajax?.nonce   || ''

    // Read initial state from the server-rendered page
    const raw = this.postsWrap?.dataset.initialState
    const init = raw ? (() => { try { return JSON.parse(raw) } catch(_) { return {} } })() : {}
    this.activeGenre = init.genre  || 'all'
    this.controller  = null
    this.debounce    = null
    this.pillsWrap   = document.querySelector('[data-mobile-active-filters]')

    // Record initial history state so back-button can restore the server render
    const initParams = this.buildParams({ paged: init.paged || 1 })
    history.replaceState({ liveSearch: true, params: initParams }, '', window.location.href)

    this.bindEvents()
    this.syncGenreUI()
    this.syncLevelChipUI()
    this.syncMobilePills()
    this.syncFilterBadge()
    this.syncLanguageNotice()
  }

  bindEvents() {
    // Search — debounced 300 ms
    if (this.searchInput) {
      this.searchInput.addEventListener('input', () => {
        clearTimeout(this.debounce)
        this.debounce = setTimeout(() => this.fetch(), 300)
      })
      this.searchInput.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') { clearTimeout(this.debounce); this.fetch() }
      })
    }

    // Genre buttons — sidebar + toolbar pills
    this.genreButtons.forEach((btn) => {
      btn.addEventListener('click', () => {
        this.activeGenre = btn.dataset.genre || 'all'
        this.syncGenreUI()
        this.syncMobilePills()
        this.fetch()
      })
    })

    // Level checkboxes
    this.levelInputs.forEach((input) => {
      input.addEventListener('change', () => {
        this.syncLevelChipUI()
        this.syncMobilePills()
        this.syncFilterBadge()
        this.fetch()
      })
    })

    this.levelChips.forEach((chip) => {
      chip.addEventListener('click', () => {
        const input = this.levelInputs.find((node) => node.value === chip.dataset.levelChip)
        if (!input) return
        input.checked = !input.checked
        this.syncLevelChipUI()
        this.syncMobilePills()
        this.syncFilterBadge()
        this.fetch()
      })
    })

    // Sort select
    if (this.sortSelect) {
      this.sortSelect.addEventListener('change', () => this.fetch())
    }

    // Pagination — event delegation so it survives innerHTML replacement
    if (this.postsWrap) {
      this.postsWrap.addEventListener('click', (e) => {
        const link = e.target.closest('.pagination__btn')
        if (!link || !link.href) return
        e.preventDefault()
        const url = new URL(link.href)
        // Query-string pagination (?paged=N) from AJAX-rendered links
        let paged = parseInt(url.searchParams.get('paged') || '0', 10)
        // Pretty-URL pagination (/page/N/) from server-rendered initial load
        if (!paged) {
          const m = url.pathname.match(/\/page\/(\d+)/)
          paged = m ? parseInt(m[1], 10) : 1
        }
        this.fetch({ paged })
      })
    }

    // Browser back / forward
    window.addEventListener('popstate', (e) => {
      if (e.state?.liveSearch) this.restoreFromState(e.state.params)
    })
  }

  buildParams(overrides = {}) {
    const sortMap = {
      date_desc:  { orderby: 'date',          order: 'DESC' },
      date_asc:   { orderby: 'date',          order: 'ASC'  },
      title_asc:  { orderby: 'title',         order: 'ASC'  },
      views_desc: { orderby: 'meta_value_num', order: 'DESC' },
    }
    const sortVal = this.sortSelect?.value || 'date_desc'
    const sort    = sortMap[sortVal] || sortMap.date_desc
    const contextTaxonomy = this.postsWrap?.dataset.contextTaxonomy || ''
    const contextTerm     = this.postsWrap?.dataset.contextTerm || ''

    return {
      action:           'akordi_live_search',
      nonce:            this.nonce,
      search:           this.searchInput?.value.trim() || '',
      genre:            this.activeGenre,
      levels:           this.levelInputs.filter((i) => i.checked).map((i) => i.value).join(','),
      paged:            1,
      orderby:          sort.orderby,
      order:            sort.order,
      context_taxonomy: contextTaxonomy,
      context_term:     contextTerm,
      ...overrides,
    }
  }

  async fetch(overrides = {}) {
    if (!this.postsWrap) return
    const params = this.buildParams(overrides)

    // Cancel any in-flight request
    if (this.controller) this.controller.abort()
    this.controller = new AbortController()

    this.setLoading(true)

    const body = new URLSearchParams()
    Object.entries(params).forEach(([k, v]) => body.append(k, String(v)))

    try {
      const res  = await fetch(this.ajaxurl, {
        method:  'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body:    body.toString(),
        signal:  this.controller.signal,
      })
      const json = await res.json()
      if (json.success) this.render(json.data, params)
    } catch (err) {
      if (err.name !== 'AbortError') console.error('[LiveSearch]', err)
    } finally {
      this.setLoading(false)
    }
  }

  render(data, params) {
    if (Array.isArray(data.search_variants) && data.search_variants.length) {
      console.debug('[Akordi search variants]', {
        search: params.search,
        variants: data.search_variants,
      })
    }

    this.syncLanguageNotice(params.search)

    // Replace posts + view-toggle + pagination
    this.postsWrap.innerHTML = data.html || ''

    // Immediately restore grid/list preference (before browser paints)
    try {
      const saved = localStorage.getItem('akordi-view')
      if (saved === 'list') {
        const g = document.getElementById('view-grid-content')
        const l = document.getElementById('view-list-content')
        if (g) g.style.display = 'none'
        if (l) l.style.display = ''
      }
    } catch (_) {}

    // Re-bind view toggle click handlers on the new DOM nodes
    initArchiveViewToggle()

    // Update result counters
    if (this.countNode) this.countNode.textContent = String(data.count ?? 0)
    if (this.totalNode) this.totalNode.textContent = String(data.total ?? 0)

    // Show empty state if no results
    const grid = document.getElementById('view-grid-content')
    if (grid && !grid.children.length) {
      const msg = document.createElement('div')
      msg.className = 'live-search-empty'
      msg.innerHTML = '<p>Нема резултати за вашето барање.</p>'
      grid.appendChild(msg)
      const listEl = document.getElementById('view-list-content')
      if (listEl) { listEl.innerHTML = ''; listEl.appendChild(msg.cloneNode(true)) }
    }

    // Scroll to show results bar (count) just below the sticky chrome
    const resultsBar = document.querySelector('.results-bar')
    if (resultsBar) {
      const stickyH = (document.querySelector('.site-header')?.offsetHeight ?? 64)
        + (document.querySelector('.toolbar-wrap')?.offsetHeight ?? 0)
        + 8
      window.scrollTo({ top: resultsBar.getBoundingClientRect().top + window.scrollY - stickyH, behavior: 'smooth' })
    }

    // Update browser URL without page reload
    this.pushState(params, data.page_url || '')

    // Signal other scripts (e.g. favorites) that the DOM changed
    document.dispatchEvent(new CustomEvent('akordi:searchRendered', { detail: data }))
  }

  pushState(params, pageUrl = '') {
    const url = pageUrl ? new URL(pageUrl, window.location.origin) : new URL(window.location.href)

    const setOrDel = (key, val, skip = '') => {
      if (val && val !== skip && val !== '') url.searchParams.set(key, val)
      else url.searchParams.delete(key)
    }

    const basePath = url.pathname.replace(/\/page\/\d+\/?$/, '/').replace(/\/+$|^$/, (match, offset, string) => {
      if (!string.startsWith('/')) return '/'
      return offset === 0 ? match : '/'
    })

    setOrDel('search',  params.search)
    setOrDel('genre',   params.genre,  'all')
    setOrDel('levels',  params.levels)

    if (!pageUrl) {
      if (params.paged > 1) {
        url.pathname = `${basePath.replace(/\/$/, '')}/page/${params.paged}/`
      } else {
        url.pathname = basePath
      }

      url.searchParams.delete('paged')
    }

    history.pushState({ liveSearch: true, params }, '', url.toString())
  }

  setLoading(on) {
    this.container.setAttribute('aria-busy', on ? 'true' : 'false')
    if (this.postsWrap) this.postsWrap.classList.toggle('posts-wrap--loading', on)
  }

  syncGenreUI() {
    this.sidebarGenreBtns.forEach((btn) => {
      btn.classList.toggle('sidebar-genre--active', (btn.dataset.genre || 'all') === this.activeGenre)
    })
    this.toolbarGenrePills.forEach((btn) => {
      btn.classList.toggle('toolbar__genre-pill--active', (btn.dataset.genre || 'all') === this.activeGenre)
    })
  }

  syncFilterBadge() {
    const badge  = document.querySelector('[data-filter-badge]')
    const toggle = document.querySelector('[data-filter-toggle]')
    const count  = this.levelInputs.filter(i => i.checked).length + (this.activeGenre !== 'all' ? 1 : 0)
    if (badge) {
      badge.textContent = String(count)
      badge.hidden = count === 0
    }
    if (toggle) {
      toggle.classList.toggle('toolbar__filter-toggle--active', count > 0)
    }
  }

  syncLanguageNotice(search = null) {
    if (!this.languageNotice) return
    const query = search !== null ? search : (this.searchInput?.value || '')
    this.languageNotice.hidden = !/[a-z]/i.test(query)
  }

  syncLevelChipUI() {
    this.levelChips.forEach((chip) => {
      const isActive = this.levelInputs.some((input) => input.value === chip.dataset.levelChip && input.checked)
      chip.classList.toggle('toolbar__level-pill--active', isActive)
      chip.setAttribute('aria-pressed', isActive ? 'true' : 'false')
    })
  }

  restoreFromState(params) {
    if (this.searchInput) this.searchInput.value = params.search || ''
    this.activeGenre = params.genre || 'all'
    const levels = params.levels ? params.levels.split(',') : []
    this.levelInputs.forEach((input) => { input.checked = levels.includes(input.value) })
    if (this.sortSelect) {
      const sortVal = LiveSearch.orderbyToSort(params.orderby, params.order)
      this.sortSelect.value = sortVal
    }
    this.syncGenreUI()
    this.syncLevelChipUI()
    this.syncMobilePills()
    this.syncFilterBadge()
    this.syncLanguageNotice()
    this.fetch({ paged: params.paged || 1 })
  }

  syncMobilePills() {
    if (!this.pillsWrap) return
    this.pillsWrap.innerHTML = ''

    if (this.activeGenre !== 'all') {
      const activeGenreBtn = this.toolbarGenrePills.find((btn) => (btn.dataset.genre || 'all') === this.activeGenre)
      const genreLabel = activeGenreBtn?.textContent.trim() || this.activeGenre
      this.pillsWrap.appendChild(this._makePill(genreLabel, () => {
        this.activeGenre = 'all'
        this.syncGenreUI()
        this.syncMobilePills()
        this.syncFilterBadge()
        this.fetch()
      }))
    }

    this.levelInputs.filter(i => i.checked).forEach(input => {
      const name = input.closest('.diff-row')?.querySelector('.diff-row__name')?.textContent.trim() || input.value
      this.pillsWrap.appendChild(this._makePill(name, () => {
        input.checked = false
        this.syncLevelChipUI()
        this.syncMobilePills()
        this.syncFilterBadge()
        this.fetch()
      }))
    })
  }

  _makePill(label, onRemove) {
    const btn = document.createElement('button')
    btn.type = 'button'
    btn.className = 'active-filters__tag'
    btn.innerHTML = `${label}<span class="active-filters__tag-remove" aria-hidden="true">×</span>`
    btn.addEventListener('click', onRemove)
    return btn
  }

  static orderbyToSort(orderby, order) {
    if (orderby === 'date' && order === 'ASC')  return 'date_asc'
    if (orderby === 'title')                    return 'title_asc'
    if (orderby === 'meta_value_num')            return 'views_desc'
    return 'date_desc'
  }
}

// ─── Archive filtering (archive.php, tag.php, category.php — client-side) ────

function initArchiveFiltering() {
  // Live-search pages use the LiveSearch class instead
  if (document.querySelector('[data-live-search]')) return

  const searchInput       = $('#search-input') || $('.toolbar__search-input')
  const topPills          = $$('.filter-pill')
  const sidebarGenreBtns  = $$('.sidebar-genre[data-genre]')
  const levelInputs       = $$('[data-level-filter]')
  const countNode         = $('#result-count')
  const totalNode         = $('#result-total')
  const cards             = $$('#view-grid-content .song-grid-card')
  const rows              = $$('#view-list-content .song-list__row')

  if (!cards.length && !rows.length) return
  if (!searchInput && !topPills.length && !sidebarGenreBtns.length && !levelInputs.length) return

  let activeGenre = sidebarGenreBtns.find((n) => n.classList.contains('sidebar-genre--active'))?.dataset.genre
    || topPills.find((n) => n.classList.contains('filter-pill--active'))?.dataset.genre
    || 'all'

  const syncGenreUI = () => {
    topPills.forEach((n) => n.classList.toggle('filter-pill--active', (n.dataset.genre || 'all') === activeGenre))
    sidebarGenreBtns.forEach((n) => n.classList.toggle('sidebar-genre--active', (n.dataset.genre || 'all') === activeGenre))
  }

  const getSelectedLevels = () => levelInputs.filter((i) => i.checked).map((i) => i.value)

  const applyFilters = () => {
    const query         = (searchInput?.value || '').trim().toLowerCase()
    const selectedLevels = getSelectedLevels()

    const filterItems = (items) => {
      let visible = 0
      items.forEach((item) => {
        const haystack    = [item.dataset.title || '', item.dataset.artist || ''].join(' ')
        const genre       = item.dataset.genre || 'all'
        const level       = item.dataset.level || 'none'
        const matchesText  = !query || haystack.includes(query)
        const matchesGenre = activeGenre === 'all' || genre.includes(activeGenre)
        const matchesLevel = !selectedLevels.length || selectedLevels.includes(level)
        const show = matchesText && matchesGenre && matchesLevel
        item.style.display = show ? '' : 'none'
        if (show) visible++
      })
      return visible
    }

    const visibleCards = filterItems(cards)
    const visibleRows  = filterItems(rows)
    const shown = visibleCards || visibleRows
    if (countNode) countNode.textContent = String(shown)
    if (totalNode) totalNode.textContent = String(cards.length || rows.length)
  }

  if (searchInput) searchInput.addEventListener('input', applyFilters)

  const bindGenreClick = (node) => {
    node.addEventListener('click', () => {
      activeGenre = node.dataset.genre || 'all'
      syncGenreUI()
      applyFilters()
    })
  }
  topPills.forEach(bindGenreClick)
  sidebarGenreBtns.forEach(bindGenreClick)
  levelInputs.forEach((input) => input.addEventListener('change', applyFilters))

  syncGenreUI()
  applyFilters()
}

// ─── Single-post features ─────────────────────────────────────────────────────

function initLyricsToggle() {
  const sheet = $('#chord-sheet')
  const btnChords = $('#view-chords')
  const btnLyrics = $('#view-lyrics')
  if (!sheet || !btnChords || !btnLyrics) return

  btnLyrics.addEventListener('click', () => {
    btnLyrics.classList.add('controls-bar__toggle-btn--active')
    btnChords.classList.remove('controls-bar__toggle-btn--active')
    $$('strong', sheet).forEach(el => el.style.display = 'none')
    trackEvent('lyrics_view_toggle', getTrackContext(btnLyrics, { view_mode: 'lyrics' }))
  })

  btnChords.addEventListener('click', () => {
    btnChords.classList.add('controls-bar__toggle-btn--active')
    btnLyrics.classList.remove('controls-bar__toggle-btn--active')
    $$('strong', sheet).forEach(el => el.style.display = '')
    trackEvent('lyrics_view_toggle', getTrackContext(btnChords, { view_mode: 'chords' }))
  })
}

function initAutoscroll() {
  const btn = $('#autoscroll-btn')
  const speedSelect = $('#autoscroll-speed')
  if (!btn) return

  let isPlaying = false
  let rafId = null
  let lastTs = 0
  let remainderPx = 0

  const getPps = () => speedSelect ? parseFloat(speedSelect.value) : 25

  const setPerformanceMode = (on) => {
    document.documentElement.style.scrollBehavior = on ? 'auto' : ''
    document.body.style.scrollBehavior = on ? 'auto' : ''
  }

  const stop = () => {
    isPlaying = false
    lastTs = 0
    remainderPx = 0
    if (rafId !== null) { cancelAnimationFrame(rafId); rafId = null }
    setPerformanceMode(false)
    btn.classList.remove('controls-bar__autoscroll--active')
    if (speedSelect) speedSelect.hidden = true
    trackEvent('autoscroll_toggle', getTrackContext(btn, {
      state: 'stop',
      speed_multiplier: speedSelect ? speedSelect.value : undefined,
    }))
  }

  const tick = (ts) => {
    if (!isPlaying) return
    if (!lastTs) { lastTs = ts; rafId = requestAnimationFrame(tick); return }

    let dt = (ts - lastTs) / 1000
    lastTs = ts
    if (!Number.isFinite(dt) || dt <= 0) { rafId = requestAnimationFrame(tick); return }
    if (dt > 0.08) dt = 0.08

    const maxY = Math.max(0, document.documentElement.scrollHeight - window.innerHeight)
    if (window.scrollY >= maxY - 1) { stop(); return }

    const raw = getPps() * dt + remainderPx
    const movePx = Math.floor(raw)
    remainderPx = raw - movePx
    if (movePx > 0) window.scrollTo(0, Math.min(maxY, window.scrollY + movePx))

    rafId = requestAnimationFrame(tick)
  }

  btn.addEventListener('click', () => {
    if (isPlaying) {
      stop()
    } else {
      isPlaying = true
      lastTs = 0
      remainderPx = 0
      setPerformanceMode(true)
      btn.classList.add('controls-bar__autoscroll--active')
      if (speedSelect) speedSelect.hidden = false
      trackEvent('autoscroll_toggle', getTrackContext(btn, {
        state: 'start',
        speed_multiplier: speedSelect ? speedSelect.value : undefined,
      }))
      rafId = requestAnimationFrame(tick)
    }
  })

  if (speedSelect) {
    speedSelect.addEventListener('change', () => { remainderPx = 0 })
  }

  document.addEventListener('visibilitychange', () => {
    if (document.hidden && isPlaying) stop()
  })
}

// ─── Authors page filtering ───────────────────────────────────────────────────

function initHeroSearchTracking() {
  const form = document.querySelector('.hero__search')
  if (!form) return

  form.addEventListener('submit', () => {
    const input = form.querySelector('.hero__search-input')
    trackEvent('homepage_search_submit', getTrackContext(form, {
      search_term: normalizeTrackValue(input?.value),
    }))
  })
}

function initAuthorsFiltering() {
  const searchInput = document.getElementById('authors-search')
  if (!searchInput) return

  const groups  = Array.from(document.querySelectorAll('.authors-group'))
  const countEl = document.getElementById('authors-visible-count')
  const emptyEl = document.getElementById('authors-empty')

  const applyFilter = () => {
    const query = searchInput.value.trim().toLowerCase()
    let visible = 0

    groups.forEach((group) => {
      const cards = Array.from(group.querySelectorAll('.artist-card'))
      let groupVisible = 0
      cards.forEach((card) => {
        const name = card.dataset.name || ''
        const show = !query || name.includes(query)
        card.style.display = show ? '' : 'none'
        if (show) groupVisible++
      })
      group.style.display = groupVisible > 0 ? '' : 'none'
      visible += groupVisible
    })

    if (countEl) countEl.textContent = String(visible)
    if (emptyEl) emptyEl.style.display = visible === 0 ? '' : 'none'
  }

  searchInput.addEventListener('input', applyFilter)
}

function initArchiveMobileFilters() {
  const toggle = document.querySelector('[data-filter-toggle]')
  if (!toggle) return

  const mobilePanels = document.querySelector('[data-filter-panels]')
  if (mobilePanels) {
    const isDesktop = () => window.innerWidth > 900

    const setOpen = (isOpen) => {
      const shouldOpen = !isDesktop() && isOpen
      mobilePanels.classList.toggle('toolbar__mobile-panels--open', shouldOpen)
      mobilePanels.setAttribute('aria-hidden', shouldOpen ? 'false' : 'true')
      toggle.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false')
    }

    setOpen(false)

    toggle.addEventListener('click', () => {
      if (isDesktop()) return
      setOpen(toggle.getAttribute('aria-expanded') !== 'true')
    })

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') setOpen(false)
    })

    window.addEventListener('resize', () => {
      if (isDesktop()) setOpen(false)
    })

    return
  }

  const panel = document.querySelector('[data-filter-panel]')
  const close = document.querySelector('[data-filter-close]')
  const backdrop = document.querySelector('[data-filter-backdrop]')
  if (!panel || !close || !backdrop) return

  const isDesktop = () => window.innerWidth > 900
  const toolbarWrap = document.querySelector('.toolbar-wrap')

  // Pin panel + backdrop top to the toolbar-wrap bottom edge so the
  // panel drops down from just below the sticky toolbar, and the backdrop
  // only covers the page content underneath (toolbar stays visible).
  const positionPanel = () => {
    if (!toolbarWrap) return
    const bottom = toolbarWrap.getBoundingClientRect().bottom
    panel.style.top = bottom + 'px'
    backdrop.style.top = bottom + 'px'
  }

  const setOpen = (isOpen) => {
    const shouldOpen = !isDesktop() && isOpen
    if (shouldOpen) positionPanel()
    panel.classList.toggle('archive-sidebar--open', shouldOpen)
    panel.setAttribute('aria-hidden', shouldOpen ? 'false' : 'true')
    toggle.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false')
    backdrop.hidden = !shouldOpen
    document.body.classList.toggle('archive-filters-open', shouldOpen)
  }

  setOpen(false)

  toggle.addEventListener('click', () => {
    if (isDesktop()) return
    setOpen(toggle.getAttribute('aria-expanded') !== 'true')
  })

  close.addEventListener('click', () => setOpen(false))
  backdrop.addEventListener('click', () => setOpen(false))

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') setOpen(false)
  })

  window.addEventListener('resize', () => {
    if (isDesktop()) setOpen(false)
    else if (toggle.getAttribute('aria-expanded') === 'true') positionPanel()
  })
}

// ─── Responsive sidebar / sticky header ──────────────────────────────────────

function initChordsMobileSlot() {
  const card = document.querySelector('.sidebar-card--chords')
  const mobileSlot = document.querySelector('.song-chords-mobile-slot')
  const desktopParent = document.querySelector('[data-chords-desktop-parent]')
  if (!card || !mobileSlot || !desktopParent) return

  const mq = window.matchMedia('(max-width: 960px)')
  const move = (isMobile) => {
    if (isMobile) mobileSlot.appendChild(card)
    else desktopParent.insertAdjacentElement('afterbegin', card)
  }
  move(mq.matches)
  mq.addEventListener('change', e => move(e.matches))
}

function initStickyHeader() {
  const header = $('.site-header')
  if (!header) return
  const onScroll = () => header.classList.toggle('site-header--scrolled', window.scrollY > 16)
  window.addEventListener('scroll', onScroll, { passive: true })
  onScroll()
}

function initSingleChordWidgetPlacement() {
  const chordCard = document.querySelector('.song-sidebar--chords')
  const mobileSlot = document.querySelector('.song-chords-mobile-slot')
  const desktopParent = document.querySelector('[data-chords-desktop-parent]')
  if (!chordCard || !mobileSlot || !desktopParent) return

  const syncPlacement = () => {
    if (window.innerWidth <= 960) {
      if (chordCard.parentElement !== mobileSlot) mobileSlot.appendChild(chordCard)
      return
    }
    if (chordCard.parentElement !== desktopParent) desktopParent.insertBefore(chordCard, desktopParent.firstChild)
  }
  syncPlacement()
  window.addEventListener('resize', syncPlacement)
}

// ─── Boot ─────────────────────────────────────────────────────────────────────

document.addEventListener('DOMContentLoaded', () => {
  initStickyHeader()
  initMobileNav()
  initSingleChordWidgetPlacement()
  initShareButtons()
  initCopyButtons()
  initTrackedActionButtons()
  initTrackedLinkEvents()
  initArchiveViewToggle()
  initHeroSearchTracking()
  initAuthorsFiltering()
  initArchiveMobileFilters()
  initChordsMobileSlot()
initLyricsToggle()
  initAutoscroll()

  // Live search — only on pages that opt in via data-live-search
  const liveSearchRoot = document.querySelector('[data-live-search]')
  if (liveSearchRoot) {
    new LiveSearch(liveSearchRoot)
    if (liveSearchRoot.dataset.scrollToArchive) {
      const resultsBar = document.querySelector('.results-bar')
      if (resultsBar) {
        const stickyH = (document.querySelector('.site-header')?.offsetHeight ?? 64)
          + (document.querySelector('.toolbar-wrap')?.offsetHeight ?? 0)
          + 8
        window.scrollTo({ top: resultsBar.getBoundingClientRect().top + window.scrollY - stickyH, behavior: 'smooth' })
      }
    }
  } else {
    // Client-side filtering for archive / tag / category pages
    initArchiveFiltering()
  }
})
